import { Injectable } from '@angular/core';
import { ApiRequestService } from '../shared/api-request.service';
import { Observable, of } from 'rxjs';
import { ApiResponseModel } from '../models/api-response.model';
import { IncidentWitnessModel } from './incident-witness.model';

@Injectable({
  providedIn: 'root'
})
export class IncidentWitnessService {
  private readonly resourceUrl = 'incident-witnesses';

  constructor(private api: ApiRequestService) {}

  public find(id: number): Observable<ApiResponseModel<IncidentWitnessModel>> {
    return this.api.makeRequestObservable('get', 'v1/' + this.resourceUrl + `/${id}`);
  }

  public create(
    witness: IncidentWitnessModel
  ): Observable<ApiResponseModel<IncidentWitnessModel>> {
    return this.api.makeRequestObservable('post', 'v1/' + this.resourceUrl, witness);
  }

  public update(witness: IncidentWitnessModel): Observable<{}> {
    return this.api.makeRequestObservable(
      'put',
      'v1/' + this.resourceUrl + `/${witness.id}`,
      witness
    );
  }

  public remove(ids: number[]): Observable<{}> {
    return this.api.makeRequestObservable(
      'delete',
      'v1/' + this.resourceUrl + '/' + ids.join(',')
    );
  }
}
